module.exports = __webpack_public_path__ + "img/IMG_6070_L_WoodMatted.e6ebc504.jpg";